import React from 'react'

const Loading = () => {
  return (
    <div className="loading-overlay">
      <div className="loader">
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  )
}

export default Loading
